module.exports = __webpack_public_path__ + "img/asset_edit.637e57ab.svg";